<div class="layout-container" [class.sidebar-collapsed]="isSidebarCollapsed">
  <!-- Mobile Overlay -->
  <div class="mobile-overlay" 
       *ngIf="isMobile && !isSidebarCollapsed" 
       (click)="toggleSidebar()">
  </div>

  <!-- Sidebar -->
  <aside class="sidebar" aria-label="Sidebar" [class.collapsed]="isSidebarCollapsed">
    <div class="sidebar-content">
      <app-user-profile 
        [user]="userProfile"
        [showToggle]="true"
        [contextType]="contextType"
        (toggleSidebar)="toggleSidebar()">
      </app-user-profile>
      <div class="sidebar-navigation" [class.collapsed]="isSidebarCollapsed">
        <app-navigation-group 
          *ngFor="let group of navigationGroups"
          [title]="group.title"
          [links]="group.links"
          [color]="group.color"
          [collapsed]="isSidebarCollapsed"
          (linkClicked)="onNavigationLinkClicked()">
        </app-navigation-group>
      </div>
    </div>
    <div class="sidebar-footer" *ngIf="!isSidebarCollapsed && !isMobile">
      <img src="assets/img/cdslogo.png" alt="Logo" class="logo">
    </div>
  </aside>

  <!-- Main content area -->
  <div class="main-content">
    <!-- Header -->
    <header class="header">
      <div class="header-content">
        <div class="header-left">
          <button class="mobile-menu-toggle" 
                  *ngIf="isMobile" 
                  (click)="toggleSidebar()"
                  [attr.aria-label]="'generic.toggle_navigation_menu' | translate">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
        </div>
        <div class="header-selectors">
          <!-- Tenant selection dropdown - only visible for admin/super admin with multiple tenants -->
          <div class="tenant-select-container" *ngIf="isTenantSelectVisible()">
            <app-simple-select 
              [options]="tenantOptions$ | async" 
              [selectedOption]="selectedTenantId$ | async" 
              (selectedOptionChange)="onTenantChange($event)" 
              [noBorder]="true" 
              >
            </app-simple-select>
          </div>
          <div class="tenant-select-container" *ngIf="!isTenantSelectVisible()">
            {{tenantTitle}}
          </div>
          
          
          <!-- hide the area select if the user is not admin and has only one area -->
          <div class="area-select-container" *ngIf="isAreaSelectVisible()">
            <app-simple-select 
              [options]="areaOptions$ | async" 
              [selectedOption]="selectedAreaId$ | async" 
              (selectedOptionChange)="onUserAreaChange($event)" 
              [noBorder]="true" 
              >
            </app-simple-select>
          </div>
        </div>
      </div>
    </header>

    <!-- Page content -->
    <main class="page-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div> 